import { render, staticRenderFns } from "./DescriptionAddress.vue?vue&type=template&id=1ce141c4&scoped=true"
import script from "./DescriptionAddress.vue?vue&type=script&lang=js"
export * from "./DescriptionAddress.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAddress.vue?vue&type=style&index=0&id=1ce141c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce141c4",
  null
  
)

export default component.exports